import { h } from 'preact'

/* eslint-disable import/no-internal-modules */
import globals from '@insided/deprecated-utils/globals'
import ButtonControl from '@insided/deprecated-preact-components/button-control'

export const ModalTitle = ({ title, imageName }: { title: string, imageName: string }) => {
  return (
    <h3 className='modal-title'>
      <span className='modal-title-image'>
        <img height={32} width={32} src={`${globals('basePath')}images/integrations/${imageName}-s.png`} />
      </span>
      <span className='modal-title-text'>{title}</span>
    </h3>
  )
}

interface ModalActionButtonsProps {
  isLoading: boolean
  onSubmit: () => void
  closeModal: () => void
}

export const ModalActionButtons = ({ isLoading, onSubmit, closeModal }: ModalActionButtonsProps) => {
  return (
    <div className='modal-action-buttons-container'>
      <ButtonControl
        size='medium'
        variant='brand'
        newStyle
        title='Create'
          // eslint-disable-next-line @gorazdo/preact/prefer-classname
        class='qa-modal-create-button'
        onClick={() => onSubmit()}
        isLoading={isLoading}
      />
      <ButtonControl newStyle size='medium' title='Cancel' onClick={() => closeModal()} />
    </div>
  )
}
